
const Footer = () => {

  const currentYear = new Date().getFullYear();

  return (
    <footer
      style={{
        background: "#000",
        textAlign: "left",
        padding: "2px 0px 5px 8px",
        zIndex: 100,
        position: "fixed",
        bottom: 0,
        width: "100%",
      }}
    >
      <p style={{ margin: 0, fontSize: "10px", fontWeight: "600",color: '#fff' }}>
        &copy; {currentYear} The Coca-Cola Company. All rights reserved.
      </p>
    </footer>
  );
};

export default Footer;

